<mat-sidenav-container>
    <mat-sidenav-content>
        <div class="page color">
            <div class="main">
                <img class="logos" [src]="logos" width="100%" alt="logos">
                <h1>Error del Servidor</h1>
                <div class="error-code">404</div>
                <h2>Página No Encontrada</h2>
                <p class="lead">Esta página no existe o se movió a otro lugar.</p>
                <hr />
                <p>Esto es lo que puedes hacer:</p>
                <div class="help-actions">
                    <a mat-stroked-button color="primary" href="javascript:location.reload();">Recargar Página</a>
                    <a mat-stroked-button color="primary" href="javascript:history.back();">Volver a la Página Anterior</a>
                    <a mat-stroked-button color="primary" href="/">Página de Inicio</a>
                </div>
            </div>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
